var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49993 4.5C9.49993 4.22386 9.72378 4 9.99993 4C10.2761 4 10.4999 4.22386 10.4999 4.5V14.2858L13.4393 11.3464C13.6345 11.1512 13.9511 11.1512 14.1464 11.3464C14.3416 11.5417 14.3416 11.8583 14.1464 12.0536L10.4001 15.7998C10.3716 15.8378 10.3378 15.8716 10.2998 15.9001L10.2573 15.9426C10.2544 15.9397 10.2515 15.9368 10.2486 15.9339C10.1754 15.9759 10.0905 16 9.99993 16C9.90939 16 9.82448 15.9759 9.75123 15.9339L9.74257 15.9426L9.70007 15.9001C9.66208 15.8716 9.62829 15.8378 9.59978 15.7999L5.85348 12.0536C5.65822 11.8583 5.65822 11.5417 5.85348 11.3464C6.04874 11.1512 6.36532 11.1512 6.56058 11.3464L9.49993 14.2858V4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.5039b9c44e076d4ec655e588b65213b7.svg";
export { ForwardRef as ReactComponent };